import HourlyCost from "../hourly-cost";
import {DeltaEventMethodType} from "../../../gd/manager/delta-handler/types";
import HourlyCostHistory from "../hourly-rate-history/hourly-cost-history";


export function hourlyCost_onSessionEvent(hourlyCost:HourlyCost, method:string, data:any, header:any) {

    // never initialized - skip
    if (!gd._hourlyCost) return

    switch (method) {

        case DeltaEventMethodType.NEW:
            const newModel = new HourlyCostHistory(data)
            hourlyCost.addHourlyCostHistory(newModel)
            break

        case DeltaEventMethodType.DELETE:
            hourlyCost.hourlyCostHistoryCollection.remove(header.id)
            hourlyCost.resetFromCollection()
            break

        case DeltaEventMethodType.DELTA:
            // hourlyCost.hourlyCostHistoryCollection.remove(header.id)
            // hourlyCost.resetFromCollection()
            break

    }



}